import ArrowBottom from "assets/svg/arrow-bottom.svg";
import { Button } from "components";
import Link from "next/link";
import React, { useRef, useState } from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { Title } from "../..";
import style from "./style.module.css";

function Teachers({ data }: { data: any }): JSX.Element {
  const [swiperRef, setSwiperRef]: any = useState(null);
  return (
    <div className="mb-5 flex w-full flex-col px-[10%]">
      <div className="">
        <Title title="اساتید ما" wrapperClass="mb-9" />
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          slidesPerView={1}
          spaceBetween={0}
          modules={[Pagination]}
          className="mySwiper flex justify-center"
          onSwiper={setSwiperRef}
        >
          {data?.map((a: any, index: number) => (
            <SwiperSlide key={a?.id?.toString()}>
              <div className="grid grid-cols-1 justify-center justify-items-center px-1 lg:grid-cols-[_1fr,1.3fr]">
                <Link
                  href={{
                    href: `/teacher/${a?.id}`,
                    pathname: a?.seoUrlDescription
                      ? `/teacher/${a?.id}/${encodeURIComponent(
                          a?.seoUrlDescription
                        )}`
                      : `/teacher/${a?.id}`,
                  }}
                >
                  <div className="relative flex h-80 w-full cursor-pointer items-end justify-start md:h-96 md:justify-center xl:justify-start">
                    <div
                      className="relative right-0 h-72 w-11/12 justify-self-start rounded-lg md:h-80 md:w-96 md:justify-self-auto"
                      style={{
                        background:
                          "linear-gradient(238.69deg, rgba(54, 100, 147, 0.88) 3.2%, rgba(4, 128, 212, 0.88) 44.48%, rgba(39, 177, 187, 0.88) 83.25%)",
                      }}
                    >
                      <div
                        className="absolute top-1/2 -left-4 h-[15rem] w-11/12 -translate-y-1/2 rounded-lg md:-left-10 md:h-[18rem] md:w-[22rem]"
                        style={{
                          background:
                            "linear-gradient(145.52deg, #2C343E 20.36%, #0678B0 97.71%)",
                        }}
                      >
                        <img
                          loading="lazy"
                          src={a.image ?? "images/person.png"}
                          alt="person"
                          className="absolute bottom-0 left-0 h-[125%] w-auto rounded-b-lg object-cover md:h-[120%]"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
                <div className="mt-5 flex h-full flex-col justify-start justify-self-start text-[#4E4E56]">
                  <div className="flex h-full flex-col justify-evenly md:pb-10">
                    <div>
                      <span className="mb-8 text-sm md:text-xl">
                        {a?.fullName}
                      </span>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: a?.description,
                        }}
                        className={style.customList}
                      />
                    </div>
                    {/* <div className="flex">
                                            <Button
                                                name="slide-prev"
                                                className={`${
                                                    index == 0 ? 'bg-blue/10' : 'bg-blue'
                                                } ml-2 flex h-7 w-7 -rotate-90 items-center justify-center rounded-full`}
                                                onClick={() => swiperRef?.slidePrev()}
                                            >
                                                <ArrowBottom
                                                    className={
                                                        index == 0 ? 'fill-blue/10' : 'fill-white'
                                                    }
                                                />
                                            </Button>
                                            <Button
                                                name="slide-next"
                                                className={`flex h-7 w-7 rotate-90 items-center justify-center rounded-full ${
                                                    index + 1 == data?.length
                                                        ? 'bg-blue/10'
                                                        : 'bg-blue'
                                                }`}
                                                onClick={() => swiperRef?.slideNext()}
                                            >
                                                <ArrowBottom
                                                    className={
                                                        index + 1 == data?.length
                                                            ? 'fill-blue/10'
                                                            : 'fill-white'
                                                    }
                                                />
                                            </Button>
                                        </div> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Teachers;
